module.exports = __webpack_public_path__ + "img/Equipa_Ergon_2.bb590e4b.png";